const Footer = () => {
  const copyrightVersion = "1.04.2410.2822";
  return (
    <footer className="wrapper-bottom flex justify-center items-start sm:min-h-36">
      <div className="pt-6 pb-4 px-2 flex flex-col justify-end max-w-[470px] min-w-[470px] h-full items-center gap-5">
        <img src="/fidelity.png" alt="Fidelity" height={43} width={109} />
        <div className="text-gray-400 text-xs">
          © Copyright 2024 Cardknox ({copyrightVersion})
        </div>
      </div>
    </footer>
  );
};

export default Footer;
